export const getCompactPaginationItems = (totalPages, currentPage) => {
  const pageCount = Math.max(1, Number(totalPages) || 1);
  const activePage = Math.min(pageCount, Math.max(1, Number(currentPage) || 1));

  const range = (start, end) => Array.from({ length: end - start + 1 }, (_, index) => start + index);

  if (pageCount <= 9) {
    return range(1, pageCount);
  }

  if (activePage <= 5) {
    return [...range(1, 5), 'ellipsis-end', ...range(pageCount - 2, pageCount)];
  }

  if (activePage >= pageCount - 4) {
    return [...range(1, 3), 'ellipsis-start', ...range(pageCount - 4, pageCount)];
  }

  return [
    1,
    2,
    'ellipsis-start',
    activePage - 1,
    activePage,
    activePage + 1,
    'ellipsis-end',
    pageCount - 1,
    pageCount,
  ];
};
